$(document).ready(function () {
    const $html = $('html');
    const $body = $('body');

    //Hamburger
    let $button_close = $('[data-bs-toggle="collapse"].hamburger');

    if ($button_close.length > 0) {
        $button_close.on('click', function () {
            let $this = $(this);

            if (!$this.hasClass('is-active')) {
                $this.addClass('is-active');

                if ($(window).width() < 992) {
                    $body.addClass('menu-open');
                    $html.addClass('menu-open');
                }
            } else {
                $this.removeClass('is-active');
                $body.removeClass('menu-open');
                $html.removeClass('menu-open');
            }
        });
    }
});